import { configureStore } from '@reduxjs/toolkit';
import secretsReducer from './slices/secretsSlice';

const store = configureStore({
  reducer: {
    secrets: secretsReducer,
  },
});

export default store;
